import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/** @typedef {import('@/types/api').PromoCode} PromoCode */

export const PROMO_CODE_TYPE_OPTIONS = [
  { value: 'percent', label: 'Percent' },
  { value: 'flat', label: 'Flat amount' },
]

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: PromoCode[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchPromoCodesPage(params = {}) {
  const { data } = await api.get('/masters/promo-codes', { params })
  const parsed = parseMasterCatalogResponse(data, 'promo_codes')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<PromoCode[]>}
 */
export async function fetchPromoCodesList(params = {}) {
  const { data } = await api.get('/masters/promo-codes', { params })
  return data.data.promo_codes
}

/**
 * @returns {Promise<PromoCode[]>}
 */
export async function fetchPromoCodes() {
  return fetchPromoCodesList()
}

/**
 * @param {Partial<PromoCode>} payload
 * @returns {Promise<PromoCode>}
 */
export async function createPromoCode(payload) {
  const { data } = await api.post('/masters/promo-codes', payload)
  return data.data.promo_code
}

/**
 * @param {number} promoCodeId
 * @param {Partial<PromoCode>} payload
 * @returns {Promise<PromoCode>}
 */
export async function updatePromoCode(promoCodeId, payload) {
  const { data } = await api.put(`/masters/promo-codes/${promoCodeId}`, payload)
  return data.data.promo_code
}
